/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
	const siteNavigation = document.getElementById('masthead');

	// Return early if the navigation doesn't exist.
	if (!siteNavigation) {
		return;
	}

	// Get navigation and button
	const targetElement = document.querySelector('#site-navigation');
	const button = siteNavigation.parentNode.getElementsByTagName('button')[0];

	// Return early if the button doesn't exist.
	if ('undefined' === typeof button) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName('ul')[0];

	// Hide menu toggle button if menu is empty and return early.
	if ('undefined' === typeof menu) {
		button.style.display = 'none';
		return;
	}

	if (!menu.classList.contains('nav-menu')) {
		menu.classList.add('nav-menu');
	}

	const theHTML = document.querySelector('html');

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener('click', function () {
		void this.clientWidth;
		if (siteNavigation.classList.contains('menu-toggled')) {
			siteNavigation.classList.remove('menu-toggled');
			theHTML.classList.remove('menu-toggled');
			siteNavigation.classList.add('menu-untoggled');
			theHTML.classList.add('menu-untoggled');
			const body = document.body;
			const scrollY = body.style.top;
			body.style.top = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		} else {
			siteNavigation.classList.remove('menu-untoggled');
			theHTML.classList.remove('menu-untoggled');
			siteNavigation.classList.add('menu-toggled');
			theHTML.classList.add('menu-toggled');
			const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
			const body = document.body;
			body.style.top = `-${scrollY}`;
		}

		if (button.getAttribute('aria-expanded') === 'true') {
			button.setAttribute('aria-expanded', 'false');
		} else {
			button.setAttribute('aria-expanded', 'true');
		}

	});

	// Remove the .menu-toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', function (event) {
		const isClickInside = siteNavigation.contains(event.target);

		if (!isClickInside) {
			siteNavigation.classList.remove('menu-toggled');
			theHTML.classList.remove('menu-toggled');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName('a');

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');

	// Toggle focus each time a menu link is focused or blurred.
	for (const link of links) {
		link.addEventListener('focus', toggleFocus, true);
		link.addEventListener('blur', toggleFocus, true);
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for (const link of linksWithChildren) {
		link.addEventListener('touchstart', toggleFocus, false);
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if (event.type === 'focus' || event.type === 'blur') {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains('nav-menu')) {
				// On li elements toggle the class .focus.
				if ('li' === self.tagName.toLowerCase()) {
					self.classList.toggle('focus');
				}
				self = self.parentNode;
			}
		}

		if (event.type === 'touchstart') {
			const menuItem = this.parentNode;
			event.preventDefault();
			for (const link of menuItem.parentNode.children) {
				if (menuItem !== link) {
					link.classList.remove('focus');
				}
			}
			menuItem.classList.toggle('focus');
		}
	}

	// Add classes class to body if document is scrolled.
	window.onscroll = function fixHeader() {

		// Get position
		var scrollPosY = window.pageYOffset | document.body.scrollTop;

		// Add or remove class "scrolled".
		if (scrollPosY > 35) {
			document.body.classList.add('scrolled');
		} else if (scrollPosY <= 1) {
			document.body.classList.remove('scrolled');
		}

	};

	// When clicking an anchor link, animate to anchor
	document.querySelectorAll('main a[href^="#"]').forEach(trigger => {
		trigger.onclick = function (e) {
			if (!this.classList.contains('no-smooth-scrolling') || !this.classList.contains('cmplz-link')) {
				e.preventDefault();
				let hash = this.getAttribute('href');
				let target = document.querySelector(hash);
				let headerOffset = 65
				let elementPosition = target.offsetTop;
				let offsetPosition = elementPosition - headerOffset;

				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth"
				});
			}
		};
	});

	// iOS scroll hack - hat tip css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
	window.addEventListener('scroll', () => {
		document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
	});

	// Search
	if (document.querySelector('#search')) {
		document.querySelector('#search').onclick = function (e) {
			e.preventDefault();
			document.body.classList.add('search-open');
			document.querySelector('#search input').focus();
			document.querySelector('#search').classList.add('active');
			if (document.querySelector('#search input').value.length != 0) {
				document.getElementById('search-form').submit();
			};
		}
		document.querySelector('#search-clickout').onclick = function (e) {
			e.preventDefault();
			document.body.classList.remove('search-open');
			document.querySelector('#search').classList.remove('active');
		};
	}

}());
